import { render, staticRenderFns } from "./fileComponent.vue?vue&type=template&id=d6f18cb6"
import script from "./fileComponent.vue?vue&type=script&lang=js"
export * from "./fileComponent.vue?vue&type=script&lang=js"
import style0 from "./fileComponent.vue?vue&type=style&index=0&id=d6f18cb6&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6f18cb6')) {
      api.createRecord('d6f18cb6', component.options)
    } else {
      api.reload('d6f18cb6', component.options)
    }
    module.hot.accept("./fileComponent.vue?vue&type=template&id=d6f18cb6", function () {
      api.rerender('d6f18cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedbackStatistics/components/fileComponent.vue"
export default component.exports